import React from "react";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

import { apiGet } from "../../Api";
import withTitle from "../withTitle";

import HasRight from "../HasRight";
import ViewToolbar from "../ViewToolbar";

import "../../blocks.css";
import "../../icomoon.css";
import "../../indicator.css";
import "../../list.css";
import "../../spinner.css";
import "../../table.css";
import "../../user.css";
import "../viewer.css";

interface IGroupsViewState {
    isLoading: boolean;
    error?: string;
    groups: any[];
    filteredGroups: any[];
    searchText: string;
}

class GroupsView extends React.Component<{}, IGroupsViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            groups: [],
            isLoading: false,

            filteredGroups: [],
            searchText: ""
        }

        this.changeSearchChange = this.changeSearchChange.bind(this);
    }

    public async componentDidMount() {
        try {
            this.setState({
                error: undefined,
                isLoading: true
            });
            const groups = await apiGet<any[]>("employees/groups");

            this.setState({
                groups,
                filteredGroups: groups,
                isLoading: false,
            });
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <HasRight right="employee:create">
                        <Link to="/groups/add" className="icon-plus" />
                    </HasRight>
                </ViewToolbar>
                <div className="filter-control-box">
                    <input type="search" className="fill-space" placeholder="Search..." value={this.state.searchText} onChange={this.changeSearchChange} />
                </div>

                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest">Members</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Employees</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading
                                ? <tr>
                                    <td colSpan={10}>
                                        <div className="spinner-center lds-dual-ring" />
                                    </td>
                                </tr>
                                : this.state.filteredGroups.map(a => (
                                    <tr key={a.id}>
                                        <td>{a.name}<small className="text-light"><br />{a.isWellKnown && !a.description ? "Built-in group" : a.description}</small></td>
                                        <td>{a.memberCount}</td>
                                        <td>
                                            <HasRight right="employee:write">
                                                <Link to={`/groups/${a.id}`} className="button small text-with-icon">
                                                    {a.isWellKnown
                                                        ? <span>View</span>
                                                        : <span>Edit</span>}
                                                </Link>
                                            </HasRight>
                                        </td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    private changeSearchChange(e: ChangeEvent<HTMLInputElement>) {
        const searchValue = e.currentTarget.value.toLowerCase();
        this.setState(s => {
            return {
                searchText: searchValue,

                filteredGroups: searchValue ? s.groups.filter(g =>
                    g.name.toLowerCase().includes(searchValue) || 
                    (g.description && g.description.toLowerCase().includes(searchValue))
                ) : s.groups
            }
        });
    }
}

export default withTitle("Employee Groups", GroupsView);
